import EconomicCalendarTable from "@/ui-components/economic-calendar-table";
import useAuth from "@/hooks/useAuth";
import DemoBanner from "@/ui-components/DemoBanner";

const EconomicCalendarPage = () => {
  const { authenticated } = useAuth();

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-gray-100 dark:bg-gray-950 transition-colors">
      {!authenticated && <DemoBanner message="previous day's calendar" />}
      <div className="flex-1 min-h-0 p-2">
        <div className="h-full bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700/50 rounded-lg flex flex-col overflow-hidden">
          <EconomicCalendarTable
            bodyRowClassNames="text-sm text-gray-700 dark:text-gray-300"
            bodyCellClassNames="py-1"
            isDemo={!authenticated}
          />
        </div>
      </div>
    </div>
  );
};

export default EconomicCalendarPage;
